import React, { useState, useEffect } from "react";
import {
  Breadcrumb,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Nav,
  Row,
  Stack,
} from "react-bootstrap";
import Confirm from "../Confirm";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import FilesCreate from "../file/FilesCreate";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import RelatedListFiles from "../file/RelatedListFiles";
import RelatedListTask from "../task/RelatedListTask";
import TaskEdit from "../task/TaskEdit";
import * as constants from "../../constants/CONSTANT";
import Image from "react-bootstrap/Image";
import moment from "moment";
import { disableCursor } from "@fullcalendar/core/internal";
import Permissionhelper from "../common/Permissionhelper";
import { ROUTES } from "../../constants/webRouting";
import solisPowerApi from "../../api/solisPowerApi";
import PERMISSIONS from "../../constants/permissions";
import { getUserDetails } from "../../utils/helper";

const ContactView = (props) => {
  const userInfo = getUserDetails();
  const location = useLocation();
  const navigate = useNavigate();
  //const contact = location.state;
  const [contact, setContact] = useState(location.state ? location.state : {});
  const [relatedListFiles, setRelatedListFiles] = useState(true);
  const [modalShowFile, setModalShowFile] = useState(false);
  const [modalShowTask, setModalShowTask] = useState(false);
  const [relatedListTask, setRelatedListTask] = useState(false);
  const [refreshFileList, setRefreshFileList] = useState();
  // const [reletedListBusiness, setRelatedListBusiness] = useState(false);
  const [refreshTaskList, setRefreshTaskList] = useState();
  // const [currentRec, setCurrentRecord] = useState({});
  // const [locationRecordv1, setLocationRecordv1] = useState({});
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [address, setAddress] = useState(
    `${contact.street} ${contact.state} ${contact.zipcode}`
  ); // Default address
  // const [buttonDisabledv1, setButtonDisabledv1] = useState(false);
  // const [remarksv1, setRemarksv1] = useState("");

  // const [alert, setAlert] = useState(null);
  // const [spinner, setSpinner] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [imageData, setImageData] = useState();
  const [mapLocation, setMapLocation] = useState(false);

  useEffect(() => {
    fetchContact();
    setMapLocation(true);
  }, []);

  useEffect(() => {
    const loadGoogleMapsScript = () => {
      // console.log(window.google)
      if (!window.google) {
        const googleMapScript = document.createElement("script");
        googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyC_62P9eUo4w05IfwuHdnUiQRO1mPFT1CM&callback=initMap`;
        googleMapScript.async = true;
        googleMapScript.defer = true;
        window.document.body.appendChild(googleMapScript);
      } else {
        window.initMap();
      }
    };

    window.initMap = () => {
      myMapFunction();
    };

    loadGoogleMapsScript();
  }, [latitude, longitude, address]);

  const myMapFunction = async () => {
    if (!latitude || !longitude) {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address: address }, (results, status) => {
        if (status === "OK") {
          const location = results[0].geometry.location;

          setLatitude(location.lat());
          setLongitude(location.lng());

          const mapProp = {
            center: location,
            zoom: 14,
          };

          const map = new window.google.maps.Map(
            document.getElementById("googleMapaddress"),
            mapProp
          );

          const marker = new window.google.maps.Marker({
            map,
            position: location,
            title: results[0].formatted_address,
          });

          const infowindow = new window.google.maps.InfoWindow({
            content: results[0].formatted_address,
          });

          marker.addListener("click", () => {
            infowindow.open(map, marker);
          });

          setAddress(results[0].formatted_address);
        } else {
          console.error(
            "Geocode was not successful for the following reason: " + status
          );
        }
      });
    } else {
      // console.log("==>", latitude, latitude, address);
      const location = new window.google.maps.LatLng(latitude, longitude);
      const mapProp = {
        center: location,
        zoom: 14,
      };

      const map = new window.google.maps.Map(
        document.getElementById("googleMapaddress"),
        mapProp
      );

      const marker = new window.google.maps.Marker({
        map,
        position: location,
        title: address,
      });

      const infowindow = new window.google.maps.InfoWindow({
        content: address,
      });

      marker.addListener("click", () => {
        infowindow.open(map, marker);
      });
    }
  };

  const submitTasks = () => {
    setModalShowTask(false);
    setRefreshTaskList(Date.now());
  };

  const handleSelect = (key) => {
    if (key === "files") {
      setRelatedListFiles(true);
      setRelatedListTask(false);
    } else if (key === "tasks") {
      setRelatedListFiles(false);
      setRelatedListTask(true);
    }
  };

  const submitFiles = () => {
    setModalShowFile(false);
    setRefreshFileList(Date.now());
    setModalShowTask(false);
    fetchContact();
  };

  const fetchContact = () => {
    // Coming from Email
    if (!contact.id && location.hasOwnProperty("pathname")) {
      contact.id = location.pathname.split("/")[2];
      //console.log("pathnam===" + contact.id);
    }
    async function initContact() {
      let result = await solisPowerApi.fetchContactById(
        contact.id ? contact.id : location?.state?.id
      );
      if (result?.id) {
        let productImageResult = await solisPowerApi.fetchPrimaryImages(
          contact.id
        );

        if (productImageResult?.id) {
          let productImageData = await solisPowerApi.downloadFiles(
            productImageResult.id,
            "ContactImages"
          );

          // Convert Blob to base64 string
          let reader = new FileReader();
          reader.readAsDataURL(productImageData);
          reader.onloadend = () => {
            let base64data = reader.result;
            console.log("Base64 Product Image:", base64data);
            if (base64data) {
              setImageData(base64data);
            }
          };
        }
      }

      if (result) {
        setContact(result);
      } else {
        setContact({});
      }
    }
    initContact();
  };

  const deleteContact = async () => {
    const result = await solisPowerApi.deleteContacts(contact.id);
    if (result.success) navigate(`/contacts`);
  };

  const editContact = () => {
    navigate(`/contacts/${contact.id}/e`, { state: contact });
  };

  return (
    <>
      {contact && (
        <Container className="pb-5">
          {modalShow && (
            <Confirm
              show={modalShow}
              onHide={() => setModalShow(false)}
              deleteContact={deleteContact}
              title="Confirm delete?"
              message="You are going to delete the record. Are you sure?"
              table="contact"
            />
          )}
          <Row className="">
            <Col md={12} className="">
              <Breadcrumb>
                <Breadcrumb.Item onClick={() => navigate(ROUTES.HOME)}>
                  Home
                </Breadcrumb.Item>
                <Breadcrumb.Item onClick={() => navigate(ROUTES.CONTACT.LIST)}>
                  Contacts
                </Breadcrumb.Item>
              </Breadcrumb>
            </Col>
            <Col md={12}>
              <Row className="">
                <Col lg={8}>
                  <Card className="shadow ">
                    <CardHeader className="bg-custom text-white sticky-card-header-view">
                      <Row className="w-100">
                        <Col lg={6} className="">
                          <div className="d-flex align-items-center h-100 gap-3">
                            <h5 className="m-0">Contact</h5>
                            <h5 className="m-0">
                              {`${contact.salutation || ""} ${contact.firstname || ""
                                } ${contact.lastname || ""}`}
                            </h5>
                          </div>
                        </Col>
                        <Col lg={6} className="p-0">
                          <Stack
                            direction="horizontal"
                            className="float-end"
                            gap={3}
                          >
                            {[PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_CONTACT].some(permission => {
                              return userInfo?.permissions.map(p => p.name).includes(permission);
                            })
                              &&
                              <Button
                                size="sm"
                                className="btn-edit"
                                onClick={() => editContact(true)}
                              >
                                <i className="fa-regular fa-pen-to-square"></i>
                              </Button>
                            }

                            {[PERMISSIONS.DELETE_ALL, PERMISSIONS?.DELETE_CONTACT].some(permission => {
                              return userInfo?.permissions.map(p => p.name).includes(permission);
                            }) && (
                                <Button
                                  size="sm"
                                  className="btn-delete"
                                  onClick={() => setModalShow(true)}
                                >
                                  <i className="fa fa-trash-o"></i>
                                </Button>
                              )}
                          </Stack>
                        </Col>
                      </Row>
                    </CardHeader>
                    <CardBody className="card-body-scroll">
                      <Row className="view-form">
                        {/* <Col lg={6}>
                            <label>Make Name</label> 
                            <span>{contact.account_name || ""}</span>
                        </Col> */}
                        <Col lg={6}>
                          <label>Name</label>
                          <span>
                            {contact.salutation || ""} {contact.firstname || ""}{" "}
                            {contact.lastname || ""}
                          </span>
                        </Col>

                        <Col lg={6}>
                          <label>Email</label>
                          <span>{contact.email || ""}</span>
                        </Col>

                        <Col lg={6}>
                          <label>Date of Birth</label>
                          <span>
                            {contact.date_of_birth
                              ? moment(contact.date_of_birth).format(
                                "DD MMM, yyyy"
                              )
                              : ""}
                          </span>
                        </Col>

                        <Col lg={6}>
                          <label>Mobile Number</label>
                          <span>{contact.phone || ""}</span>
                        </Col>

                        <Col lg={6}>
                          <label>WhatsApp Number</label>
                          <span>{contact.whatsapp_no || ""}</span>
                        </Col>

                        <Col lg={6}>
                          <label>Reference</label>
                          <span>
                            {contact.reference || ""}
                          </span>
                        </Col>

                        <Col lg={6}>
                          <label>Type</label>
                          <span>{contact.title || ""}</span>
                        </Col>


                        <Col lg={12} className="section-header">
                          ADDRESS INFORMATION
                        </Col>

                        <Col lg={6}>
                          <label>Location Link</label>
                          <span>{contact.location_link || ""}</span>
                          <a
                            href={
                              contact.location_link
                                ? contact.location_link
                                : disableCursor
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View Map
                          </a>
                        </Col>

                        <Col lg={6}>
                          <label>Complete Address</label>
                          <span>{contact.street || ""}</span>
                        </Col>


                        <Col lg={6}>
                          <label>State</label>
                          <span>{contact.state || ""}</span>
                        </Col>

                        <Col lg={6}>
                          <label>City</label>
                          <span>
                            {contact.city !== null ? contact.city : ""}{" "}
                            {contact.pincode || ""}
                          </span>
                        </Col>

                        <Col lg={6}>
                          <label>Country</label>
                          <span>{contact.country || ""}</span>
                        </Col>

                        <Col lg={12}>
                          {mapLocation && (
                            <div
                              id="googleMapaddress"
                              className=""
                              style={{
                                width: "100%",
                                height: "300px",
                                border: "1px solid black",
                              }}
                            ></div>
                          )}
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg={4}>
                  <div
                    className="card align-items-center shadow"
                  // style={{ width: "18rem" }}
                  >
                    <div className="card-body">
                      <h5
                        className="card-title"
                        style={{
                          textAlign: "-webkit-center",
                          fontWeight: "900",
                        }}
                      >
                        {" "}
                        Contact User Image
                      </h5>
                      <hr></hr>
                      <div className="align-items-center">
                        <Image
                          style={{
                            height: "150px",
                            width: "150px",
                            border: "12px",
                            marginLeft: "4px",
                          }}
                          src={
                            imageData && imageData.trim()
                              ? imageData
                              : "https://www.w3schools.com/bootstrap4/img_avatar3.png"
                          }
                          fluid
                          onError={(e) => {
                            e.target.onerror = null; // Prevent infinite loop
                            e.target.src =
                              "https://www.w3schools.com/bootstrap4/img_avatar3.png"; // Set fallback image
                          }}
                          alt="Profile Image"
                        />
                      </div>

                      <p
                        className="card-text"
                        style={{ textAlign: "center", marginTop: "24px" }}
                      >
                        {contact.salutation || ""} {contact.firstname || ""}{" "}
                        {contact.lastname || ""}
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>

            <Col md={12}>
              <Card bg="light" text="light" className="mb-2 mt-4 shadow ">
                <Card.Header className="d-flex justify-content-between ">
                  <Tabs
                    defaultActiveKey="files"
                    id="uncontrolled-tab-example"
                    onSelect={(key) => handleSelect(key)}
                  >
                    {[PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_FILE].some(permission => {
                      return userInfo?.permissions.map(p => p.name).includes(permission);
                    }) &&
                      <Tab eventKey="files" title="Files"></Tab>
                    }
                    {[PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_TASK].some(permission => {
                      return userInfo?.permissions.map(p => p.name).includes(permission);
                    }) &&
                      <Tab eventKey="tasks" title="Tasks"></Tab>
                    }
                  </Tabs>

                  {(relatedListFiles && [PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_FILE].some(permission => {
                    return userInfo?.permissions.map(p => p.name).includes(permission);
                  })) && (
                      <Button
                        size="sm"
                        className="float-right btn-custom"
                        onClick={() => setModalShowFile(true)}
                      >
                        New File
                      </Button>
                    )}
                  {modalShowFile && (
                    <FilesCreate
                      show={modalShowFile}
                      onHide={() => setModalShowFile(false)}
                      parent={contact}
                      table="medicaltest"
                      submitFiles={submitFiles}
                    />
                  )}

                  {(relatedListTask && [PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_TASK].some(permission => {
                    return userInfo?.permissions.map(p => p.name).includes(permission);
                  })) && (
                      <Button
                        size="sm"
                        className="float-right btn-custom"
                        onClick={() => setModalShowTask(true)}
                      >
                        New Task
                      </Button>
                    )}
                  {modalShowTask && (
                    <TaskEdit
                      show={modalShowTask}
                      onHide={() => setModalShowTask(false)}
                      parentid={contact.id}
                      table="account"
                      submitTasks={submitTasks}
                    />
                  )}
                </Card.Header>
                <Card.Body>
                  {(relatedListFiles && [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_FILE].some(permission => {
                    return userInfo?.permissions.map(p => p.name).includes(permission);
                  })) && (
                      <RelatedListFiles
                        refreshFileList={refreshFileList}
                        parent={contact}
                        submitFiles={submitFiles}
                        table="Contact"
                      />
                    )}
                  {(relatedListTask && [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_TASK].some(permission => {
                    return userInfo?.permissions.map(p => p.name).includes(permission);
                  })) ? (
                    <RelatedListTask
                      refreshTaskList={refreshTaskList}
                      parent={contact}
                    />
                  ) : (
                    ""
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      )}
    </>
  );
};
export default ContactView;
